export default __webpack_public_path__ + "static/media/cp_hero.8e11a9b5.png";